import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { logout, selectIsAuthenticated } from '@/store/authSlice'

const SESSION_DURATION_MS = 30 * 60 * 1000 // 30분

export function SessionManager() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isAuthenticated = useSelector(selectIsAuthenticated)

  useEffect(() => {
    if (!isAuthenticated) return

    const checkSession = () => {
      const loginTime = localStorage.getItem('loginTime')
      if (!loginTime) return
      if (Date.now() - parseInt(loginTime, 10) >= SESSION_DURATION_MS) {
        dispatch(logout())
        toast.warning('세션이 만료되었습니다. 다시 로그인해주세요.')
        navigate('/login')
      }
    }

    checkSession() // 마운트 시 즉시 확인
    const interval = setInterval(checkSession, 60_000) // 1분 간격
    return () => clearInterval(interval)
  }, [isAuthenticated, dispatch, navigate])

  return null
}
